<template>
    <div class="container">
        <FullPageLoading
            :show="showLoading"
            :label="labelLoading"
        />
        <div class="row">
            <Sidebar />
            <div class="col-12 col-md-9 col-lg-8 newsfeed">
                <h3>Search Results</h3>
                <div class="row">
                    <div class="col-md-12">
                        <div class="row my-2">
                            <div class="col-md-3">Fullname/Email/Register ID</div>
                            <div class="col-md-9">
                                <b-form-input
                                    v-model="form.q"
                                    type="text"
                                    placeholder="Enter Fullname/Email/Register ID"
                                ></b-form-input>
                            </div>
                        </div>
                        <div class="row my-2">
                            <div class="col-md-3">Origin Country</div>
                            <div class="col-md-9">
                                <vue-select :options="optionsCountry" v-model="form.country" :searchable="true"  multiple></vue-select>
                            </div>
                        </div>
                        <div class="row my-2">
                            <div class="col-md-3">Academic Year From</div>
                            <div class="col-md-9">
                                <vue-select :options="optionsDarmasiswaAcademicYear" v-model="form.academic_year" :searchable="true" multiple></vue-select>
                            </div>
                        </div>
                        <div class="row my-2">
                            <div class="col-md-3">Field Study</div>
                            <div class="col-md-9">
                                <vue-select :options="optionsFieldsStudy" v-model="form.field_study" :searchable="true"  multiple></vue-select>
                            </div>
                        </div>
                        <div class="row my-2">
                            <div class="col-md-3">University</div>
                            <div class="col-md-9">
                                <vue-select :options="optionsUniversity" v-model="form.university" :searchable="true" multiple></vue-select>
                            </div>
                        </div>
                        <div class="row my-2 mr-1">
                            <div class="ml-auto">
                                <button class="btn btn-primary mr-2" @click="onSearch">Search</button>
                                <button class="btn btn-primary ml-2" @click="onReset">Reset</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card p-2 mt-4" v-for="(s, index) in searchResult" :key="index" @click="visitProfile(s.id, s.full_name)" style="cursor: pointer;">
                    <div class="row">
                        <div class="col-md-2">
                            <img :src="s.photo_profile" alt="s.full_name" class="img-fluid">
                        </div>
                        <div class="col-md-10">
                            <h5>{{ s.full_name }}</h5>
                            <h6>{{ s.origin_country }}</h6>
                            <h6>{{ s.university }} - {{ s.field_study }}</h6>
                            <h6>{{ s.darmasiswa_academic_year }}</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const CryptoJS = require("crypto-js");
const config = require('../config/config.js');
const { aes } = config;
import moment from 'moment';
import FullPageLoading from './FullPageLoading.vue';
import Sidebar from './Sidebar.vue';
import VueTagsInput from '@johmun/vue-tags-input';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
    components: {
        FullPageLoading,
        VueTagsInput,
        Sidebar,
        'vue-select': vSelect
    },
    data() {
        return {
            form: {
                q: '',
                academic_year: [],
                country: [],
                university: [],
                field_study: [],
            },
            searchResult: [],
            optionsDarmasiswaAcademicYear: [],
            optionsFieldsStudy: [],
            optionsCountry: [],
            optionsUniversity: [],
            showLoading: false,
            labelLoading: 'Please Wait...',
        }
    },
    computed: {
        isLogin: function () {
            return this.$store.state.isLogin;
        },
        dataUser: function () {
            if (this.isLogin) {
                return this.$store.state.dataUser;
            } else {
                return [];
            }
        },
    },
    watch: {
        '$route.params.q': function (val) {
            this.form.q = val;
            this.onSearch();
        },
        tagsCountry: function (val) {
            this.tags = val.charAt(0).toUpperCase() + val.slice(1);
        },
        tagsUniversity: function (val) {
            this.tags = val.charAt(0).toUpperCase() + val.slice(1);
        },
    },
    async created() {
        this.form.q = this.$route.params.q;
        this.showLoading = true;
        this.labelLoading = 'Please Wait...';
        await this.getFilter();
        this.onSearch();
    },
    methods: {
        async onSearch() {
            if (this.form.q !== '') {
                this.showLoading = true;
                this.labelLoading = 'Please Wait...';

                let payload = {
                    scope: 'search',
                    data: {
                        access_token: this.dataUser.access_token,
                        filter: {},
                    },
                };

                payload.data.filter.q = this.form.q;

                if (this.form.academic_year.length > 0) {
                    payload.data.filter.academic_year = this.form.academic_year;
                }

                if (this.form.field_study.length > 0) {
                    payload.data.filter.field_of_study = this.form.field_of_study;
                }

                if (this.form.country.length > 0) {
                    payload.data.filter.country = this.form.country;
                }

                if (this.form.university.length > 0) {
                    payload.data.filter.university = this.form.university;
                }

                try {
                    let post = await this.$store.dispatch('post', payload);
                    this.showLoading = false;
                    this.searchResult = post.data.message;
                } catch (err) {
                    this.showLoading = false;
                    this.$bvToast.toast('Search Failed! Please Refresh the Page!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            }
        },
        async getFilter() {
            let payload = {
                scope: 'searchFilter',
                data: {
                    access_token: this.dataUser.access_token,
                },
            };

            try {
                let post = await this.$store.dispatch('post', payload);
                this.showLoading = false;
                this.optionsDarmasiswaAcademicYear = post.data.message.darmasiswa_academic_year;
                this.optionsFieldsStudy = post.data.message.field_of_study;
                this.optionsCountry = post.data.message.countries;
                this.optionsUniversity = post.data.message.university;
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Load Filter Failed! Please Refresh the Page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        tagsCountryChanged(newTags) {
            this.form.country = newTags;
            this.onSearch();
        },
        tagsUniversityChanged(newTags) {
            this.form.university = newTags;
            this.onSearch();
        },
        onReset() {
            this.form.academic_year = []
            this.form.country = []
            this.form.university = []
            this.form.field_study = []
            this.onSearch();
        },
        async visitProfile(id, name) {
            this.showLoading = true;
            this.labelLoading = 'Visiting ' + name + ' Profile! Please Wait...';

            let payload = {
                scope: 'visitProfile',
                data: {
                    access_token: this.dataUser.access_token,
                    user_id: id
                },
            };

            try {
                let visit = await this.$store.dispatch('post', payload);
                if (visit.data.status) {
                    this.showLoading = false;

                    localStorage.setItem('visitProfileData', CryptoJS.AES.encrypt(JSON.stringify(visit.data.message), aes));
                    this.$router.push({name: 'visit-profile', params: { id: id, type: 'timeline' }});
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Visiting Profile Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Visiting Profile Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        }
    },
}
</script>